import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BellIcon, ClockIcon, TrophyIcon } from 'lucide-react';
export function NotificationSettings() {
  const {
    isArabic
  } = useLanguage();
  const notifications = [{
    id: 'reminders',
    icon: ClockIcon,
    title: {
      en: 'Study Reminders',
      ar: 'تذكير الدراسة'
    },
    description: {
      en: 'Daily reminders to complete your lessons',
      ar: 'تذكير يومي لإكمال دروسك'
    }
  }, {
    id: 'achievements',
    icon: TrophyIcon,
    title: {
      en: 'Achievement Alerts',
      ar: 'تنبيهات الإنجازات'
    },
    description: {
      en: 'Notifications when you earn badges or complete milestones',
      ar: 'إشعارات عند كسب الشارات أو إكمال المراحل'
    }
  }];
  return <div className="space-y-8" data-id="element-1182">
      {/* Notification Preferences */}
      <div data-id="element-1183">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1184">
          {isArabic ? 'إعدادات الإشعارات' : 'Notification Settings'}
        </h3>
        <div className="space-y-4" data-id="element-1185">
          {notifications.map(notification => <div key={notification.id} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900/50 rounded-lg" data-id="element-1186">
              <div className="flex items-center gap-3" data-id="element-1187">
                <notification.icon className="w-5 h-5 text-gray-500" data-id="element-1188" />
                <div data-id="element-1189">
                  <div className="font-medium text-gray-900 dark:text-white" data-id="element-1190">
                    {isArabic ? notification.title.ar : notification.title.en}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-1191">
                    {isArabic ? notification.description.ar : notification.description.en}
                  </div>
                </div>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-1192">
                <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1193" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" data-id="element-1194"></div>
              </label>
            </div>)}
        </div>
      </div>
      {/* Reminder Schedule */}
      <div data-id="element-1195">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1196">
          {isArabic ? 'جدول التذكير' : 'Reminder Schedule'}
        </h3>
        <div className="space-y-4" data-id="element-1197">
          <div data-id="element-1198">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1199">
              {isArabic ? 'وقت التذكير' : 'Reminder Time'}
            </label>
            <input type="time" className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" defaultValue="09:00" data-id="element-1200" />
          </div>
          <div data-id="element-1201">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-1202">
              {isArabic ? 'أيام التذكير' : 'Reminder Days'}
            </label>
            <div className="flex flex-wrap gap-2" data-id="element-1203">
              {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => <button key={day} className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 hover:bg-blue-200 dark:hover:bg-blue-900/50 transition-colors" data-id="element-1204">
                  {day}
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}